// Keep the registry and parsing rules in sync with TwigImageMetadata.php.
export const IMAGE_FLAGS = [
    "fs", "sb", "lt", "lc", "lb", "ct", "cc", "cb", "rt", "rc", "rb",
    "sc1", "sc10", "sc11", "sc12", "sc13", "sc14", "sc15", "ai"
];

export function parseImageText(value)
{
    const flags = [];
    const original = typeof value === "string" ? value : "";
    const text = original.split(/(\s+)/).map(token =>
    {
        const flag = token.charAt(0) === "#" ? token.slice(1) : token;

        if (IMAGE_FLAGS.includes(flag))
        {
            flags.push(flag);
            return "";
        }
        return token;
    }).join("");

    return {
        text: flags.length ? text.replace(/\s+/g, " ").trim() : original,
        flags: IMAGE_FLAGS.filter(flag => flags.includes(flag))
    };
}

export function getImageMetadata(alt, title = "", extraFlags = [], fallbackAlt = "")
{
    const parsedAlt = parseImageText(alt);
    const parsedTitle = parseImageText(title);
    const flags = IMAGE_FLAGS.filter(flag =>
        parsedAlt.flags.includes(flag) || parsedTitle.flags.includes(flag) || extraFlags.includes(flag));

    return {
        alt: parsedAlt.text || parseImageText(fallbackAlt).text,
        title: parsedTitle.text,
        flags,
        // Retain the existing theme's short class aliases during migration.
        classes: flags.flatMap(flag => ["bk-img-" + flag]).join(" "),
        isAi: flags.includes("ai")
    };
}

// Used by both Vue and lozad: lozad may create an img outside Vue's VDOM.
export function syncImageAttributes(picture, img)
{
    for (const attribute of ["alt", "title"])
    {
        const value = picture.getAttribute("data-" + attribute);

        if (value !== null)
        {
            img.setAttribute(attribute, value);
        }
        else
        {
            img.removeAttribute(attribute);
        }
    }

    const previous = (img.getAttribute("data-managed-image-classes") || "").split(/\s+/).filter(Boolean);
    const next = (picture.getAttribute("data-picture-class") || "").split(/\s+/).filter(Boolean);

    for (const className of previous)
    {
        if (!next.includes(className))
        {
            img.classList.remove(className);
        }
    }
    for (const className of next)
    {
        img.classList.add(className);
    }
    img.setAttribute("data-managed-image-classes", next.join(" "));
}
